import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (_ctx.active)
        ? (_openBlock(), _createElementBlock("a", {
            key: "clear",
            tabindex: "-1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.clear()), ["prevent"]))
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-plus",
              class: "rotate-45 h-11 w-11"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}